import React from 'react';
import AdvertisementReservationExpiredContainer from 'containers/AdvertisementReservationExpiredContainer';

export default function AdvertisementReservationExpiredPage() {
  return <AdvertisementReservationExpiredContainer />;
}
